export default __webpack_public_path__ + "static/media/blank-profile.a9136072.jpg";